export default {
    space: {
        4: "2.75rem"
    }
};